import "./Lymphdrainage.module.css";
import Header from "@/reusable_sections/Header";
import Wirkprinzipprocess from "./sections/Wirkprinzipprocess";
import Daswirkprinzip from "./sections/Daswirkprinzip";
import LymphdrainageHero from "./sections/LymphdrainageHero";
import Productintroduction from "./sections/Productintroduction";
import MedicalIndications from "./sections/MedicalIndications";
import TreatmentFeatures from "./sections/TreatmentFeatures";
import DeviceVariants from "./sections/DeviceVariants";
import Trialbookingcta from "./sections/Trialbookingcta";
import Footer from "@/reusable_sections/Footer";
export default function LymphdrainagePage() {
  return <div>
      <Header />
      <LymphdrainageHero />
      <Productintroduction />
      <MedicalIndications />
      <TreatmentFeatures />
      <DeviceVariants />
      <Daswirkprinzip />
      <Wirkprinzipprocess />
      <Trialbookingcta />
      <Footer />
    </div>;
}